import CancelIcon from '@mui/icons-material/Cancel';
import Clear from '@mui/icons-material/Clear';
import DateRange from '@mui/icons-material/DateRange';
import InfoIcon from '@mui/icons-material/Info';
import SaveIcon from '@mui/icons-material/Save';
import Warning from '@mui/icons-material/Warning';
import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControlLabel,
    FormGroup,
    FormLabel,
    IconButton,
    Radio,
    RadioGroup,
    Stack,
    Switch,
    TextField,
    Tooltip,
    Typography
} from '@mui/material';
import { orange, red } from '@mui/material/colors';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import { MEIO_JULGAMENTO_SESSAO } from '@/dominio/MeioJulgamentoSessao';
import { action, computed, makeObservable, observable, reaction, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import ErrorUtil from '@/util/ErrorUtil';
import { MODALIDADE_SESSAO_JULGAMENTO } from '../dominio/ModalidadeSessaoJulgamento';
import Configuracao from '../util/Configuracao';
import ReactComponent from './ReactComponent';
import ModalConfirmacao, { TIPO_CONFIRMACAO } from './sessao/ModalConfirmacao';
import DataUtil from '@/util/DataUtil';

/** @type {string} */
const larguraColunaLabel = '320px';

class CriarOuEditarPauta extends ReactComponent {
    sistemaOrigem = this.parametroStore.isOrgaoTST ? Configuracao.ORIGEM_SIJ : Configuracao.ORIGEM_PJE;
    pautaJulgamentoInicial;
    isDataInicioJaPassou = false;
    idInicial = null;
    meioJulgumentoSessaoVirtualTela;
    /** @type {boolean} */ regrasResolucaoCnj591Form = !!this.isComponenteHabilitado('Resolucao591CNJ');
    /** @type {import('moment').Moment | null} */ dataInicioSessaoPresencial = null;
    /** @type {import('moment').Moment | null} */ horaInicioSessaoPresencial = null;
    /** @type {import('moment').Moment | null} */ dataInicioVotacaoVirtual = null;
    /** @type {import('moment').Moment | null} */ horaInicioVotacaoVirtual = null;
    /** @type {import('moment').Moment | null} */ dataFimVotacaoVirtual = null;
    /** @type {import('moment').Moment | null} */ horaFimVotacaoVirtual = null;
    /** @type {import('moment').Moment | null} */ dataFimVotacaoVirtualExibicao = null;
    /** @type {import('moment').Moment | null} */ horaFimVotacaoVirtualExibicao = null;

    isFimVotacaoVirtualDiaUtil = undefined;
    carregando = false;
    salvandoDados = false;
    confirmacaoPautaLiberada = false;
    mostrarModalConfirmacao = false;
    regrasResolucaoCnj591Default;

    constructor(props) {
        super(props);

        makeObservable(this, {
            pautaJulgamentoInicial: observable,
            isDataInicioJaPassou: observable,
            meioJulgumentoSessaoVirtualTela: observable,
            regrasResolucaoCnj591Form: observable,
            dataInicioSessaoPresencial: observable,
            horaInicioSessaoPresencial: observable,
            dataInicioVotacaoVirtual: observable,
            horaInicioVotacaoVirtual: observable,
            dataFimVotacaoVirtual: observable,
            horaFimVotacaoVirtual: observable,
            dataFimVotacaoVirtualExibicao: observable,
            horaFimVotacaoVirtualExibicao: observable,
            isFimVotacaoVirtualDiaUtil: observable,
            carregando: observable,
            salvandoDados: observable,
            confirmacaoPautaLiberada: observable,
            mostrarModalConfirmacao: observable,
            regrasResolucaoCnj591Default: observable,
            configurarDataHoraTela: action,
            pautaJulgamento: computed,
            pautaComProcessos: computed,
            fecharModalCriarOuEditarPauta: action,
            handleClickConfirmar: action,
            salvarPautaJulgamento: action,
            dataHoraInicioSessaoPresencial: computed,
            dataHoraInicioVotacaoVirtual: computed,
            dataHoraFimVotacaoVirtual: computed,
            dataHoraFimVotacaoVirtualExibicao: computed,
            handleChangeOrigem: action,
            handleTogglePautaLiberada: action,
            handleChangeTipo: action,
            handleChangeNumeroPauta: action,
            handleConfirmacaoModal: action,
            handleCancelarModal: action,
            todosCamposBloqueados: computed,
            edicaoNumeroPautaDisabled: computed,
            edicaoTipoPautaDisabled: computed,
            handleChangeModalidadeSessaoJulgamento: action,
            handleChangeMeioJulgamentoSessaoJulgamento: action,
            handleChangeMeioJulgamentoVotacaoVirtual: action,
            meioJulgumentoSessaoJulgamento: computed,
            meioJulgumentoSessaoVirtual: computed,
            meioJulgumentoSessaoVirtualInicial: computed,
            handleChangeRegrasPeriodoVirtual: action,
            regrasResCnj591: computed,
            handleChangeDataInicioVotacaoVirtual: action,
            handleChangeHoraInicioVotacaoVirtual: action,
            handleChangeDataFimVotacaoVirtual: action,
            handleChangeHoraFimVotacaoVirtual: action,
            handleChangeDataInicioSessaoPresencial: action,
            handleChangeHoraInicioSessaoPresencial: action,
            alterarData: action,
            alterarHora: action,
            limparDataHoraInicioVotacaoVirtual: action,
            limparDataHoraFimVotacaoVirtual: action,
            limparDataHoraInicioSessaoPresencial: action,
            handleClickGerarDatasJulgamentoVirtual: action,
            dataHoraInicioSessaoPresencialValida: computed,
            dataHoraInicioVotacaoVirtualValida: computed,
            dataHoraFimVotacaoVirtualValida: computed,
            tituloOperacao: computed,
            magistrados: computed,
            origemPauta: computed,
            sessaoId: computed,
            numeroPauta: computed,
            pautaPublicada: computed,
            tipo: computed,
            modalidadeSessaoJulgamento: computed,
            handleDialogPautaLiberada: action,
            handleDialogPautaLiberadaFechar: action,
            mensagensMeioJulgamento: computed,
            mensagensJulgamentoVirtual: computed,
            tooltipBotaoSalvar: computed,
            isOrigemPautaDesabilitado: computed,
            isMeioJulgamentoVirtualDesabilitado: computed,
            isMeioJulgamentoVirtualIndisponivel: computed,
            temPendencias: computed
        });

        runInAction(() => {
            this.regrasResolucaoCnj591Default = !!this.isComponenteHabilitado('Resolucao591CNJ');
            this.regrasResolucaoCnj591Form = this.regrasResolucaoCnj591Default;
        });

        this.createReaction(
            reaction(
                () => this.pautaJulgamento,
                () => {
                    if (this.pautaJulgamento) {
                        this.pautaJulgamentoInicial = this.pautaJulgamento;
                        this.idInicial = this.parseSessaoId()?.sessaoId;
                        this.configurarDataHoraTela('InicioSessaoPresencial');
                        this.configurarDataHoraTela('InicioVotacaoVirtual');
                        this.configurarDataHoraTela('FimVotacaoVirtual');
                        this.configurarDataHoraTela('FimVotacaoVirtualExibicao');
                        this.regrasResolucaoCnj591Form = !!this.pautaJulgamento?.prazos?.regrasResolucaoCnj591;

                        if (
                            this.sessaoId &&
                            (DataUtil.isDataExataJaPassou(this.pautaJulgamento?.prazos?.dataInicioVotacaoVirtual) ||
                                DataUtil.isDataExataJaPassou(this.pautaJulgamento?.prazos?.dataInicioSessaoPresencial))
                        ) {
                            this.isDataInicioJaPassou = true;
                        } else {
                            this.isDataInicioJaPassou = false;
                        }
                    }
                }
            )
        );
    }

    isMeioJulgamentoVirtualPJeHabilitado() {
        return this.isComponenteHabilitado('JulgamentoVirtualPJe');
    }

    configurarDataHoraTela(tipoPrazo) {
        const chaveData = `data${tipoPrazo}`;
        const chaveHora = `hora${tipoPrazo}`;

        this[chaveData] = this.pautaJulgamento?.prazos[chaveData]
            ? moment(this.pautaJulgamento.prazos[chaveData], 'DD-MM-YYYY')
            : null;
        this[chaveHora] = this.pautaJulgamento?.prazos[chaveData]
            ? moment(this.pautaJulgamento.prazos[chaveData], 'DD-MM-YYYY-HH-mm-ss', true)
            : null;
    }

    get pautaJulgamento() {
        return this.sessaoStore.pautaJulgamentoModal;
    }

    get pautaComProcessos() {
        return !!this.pautaJulgamento?.quantidadeTotalProcessos;
    }

    fecharModalCriarOuEditarPauta = () => {
        this.sessaoStore.pautaJulgamentoModal = undefined;
        this.pautaJulgamentoInicial = undefined;
        this.meioJulgumentoSessaoVirtualTela = undefined;
        this.isFimVotacaoVirtualDiaUtil = undefined;
        this.regrasResolucaoCnj591Form = this.regrasResolucaoCnj591Default;
        this.carregando = false;
    };

    handleClickConfirmar = async () => {
        if (this.idInicial && this.idInicial !== this.pautaJulgamento.id) {
            let existe = await this.sessaoService.existePauta(this.pautaJulgamento.id);
            if (existe) {
                this.mensagemStore.abrirMensagemErro(
                    'O novo número da pauta já existe! Escolha um número ainda não utilizado.'
                );
                return;
            }
            await this.sessaoService.excluirPautasJulgamento(this.idInicial);
        }

        if (this.pautaPublicada) {
            this.mensagemStore.abrirMensagemAlerta('Atenção: Esta pauta já está publicada.');
        }

        this.pautaJulgamento.prazos = {
            dataInicioSessaoPresencial: this.dataHoraInicioSessaoPresencial,
            dataInicioVotacaoVirtual: this.dataHoraInicioVotacaoVirtual,
            dataFimVotacaoVirtual: this.dataHoraFimVotacaoVirtual,
            dataFimVotacaoVirtualExibicao: this.dataHoraFimVotacaoVirtualExibicao,
            regrasResolucaoCnj591: this.regrasResCnj591
        };
        if (this.pautaJulgamento.prazosPorSessao && this.pautaJulgamento.prazosPorSessao[this.pautaJulgamento.id]) {
            this.pautaJulgamento.prazosPorSessao[this.pautaJulgamento.id] = this.pautaJulgamento.prazos;
        }

        const dataInicio = moment(this.dataHoraInicioSessaoPresencial, 'DD-MM-YYYY');

        if (this.dominioStore.ehFeriadoVotacao(dataInicio)) {
            this.mostrarModalConfirmacao = true;
        } else {
            this.salvarPautaJulgamento();
        }
    };

    salvarPautaJulgamento = async () => {
        this.salvandoDados = true;
        this.carregando = true;
        let retorno;

        try {
            retorno = await this.sessaoService.gravarPautaJulgamento(this.pautaJulgamento);

            if (retorno) {
                this.mensagemStore.abrirMensagemSucesso('Dados gravados com sucesso.');

                // Atualizar localmente com os dados completos retornados pelo backend
                runInAction(() => {
                    const sessoes = this.sessaoStore.sessoesJulgamento;
                    const sessaoId = retorno?.id;

                    // Remover sessão antiga se o ID mudou (edição com alteração de número)
                    if (this.idInicial && this.idInicial !== sessaoId) {
                        const idxAntigo = sessoes.findIndex((s) => s.id === this.idInicial);

                        if (idxAntigo >= 0) {
                            sessoes.splice(idxAntigo, 1);
                        }
                    }
                    const index = sessoes.findIndex((s) => s.id === sessaoId);

                    if (index >= 0) {
                        sessoes[index] = { ...sessoes[index], ...retorno };
                    } else {
                        sessoes.push(retorno);
                    }

                    // Recalcular flags hoje/proxima
                    this.sessaoService.configurarProximaSessao(sessoes);
                });

                if (
                    this.pautaJulgamentoStore.pautaSelecionada &&
                    this.pautaJulgamento &&
                    this.pautaJulgamentoStore.pautaSelecionada.id === this.pautaJulgamento.id
                ) {
                    this.pautaJulgamentoStore.pautaSelecionada.prazos = this.pautaJulgamento.prazos;
                    await this.pautaJulgamentoStore.atualizarDataLimiteEnvioPauta();
                    this.pautaJulgamentoStore.pautaSelecionada.pautaLiberada = this.pautaJulgamento.pautaLiberada;
                }

                this.fecharModalCriarOuEditarPauta();
                this.handleDialogPautaLiberadaFechar();
            }
        } catch (error) {
            console.error('Falha ao gravar pauta [' + ErrorUtil.montarMensagemErro(error) + ']');
        } finally {
            runInAction(() => {
                this.carregando = false;
                this.salvandoDados = false;
            });
        }
    };

    get dataHoraInicioSessaoPresencial() {
        return this.getDataHoraFormatada('InicioSessaoPresencial');
    }

    get dataHoraInicioVotacaoVirtual() {
        return this.getDataHoraFormatada('InicioVotacaoVirtual');
    }

    get dataHoraFimVotacaoVirtual() {
        return this.getDataHoraFormatada('FimVotacaoVirtual');
    }

    get dataHoraFimVotacaoVirtualExibicao() {
        return this.getDataHoraFormatada('FimVotacaoVirtualExibicao');
    }

    getDataHoraFormatada(tipoPrazo) {
        let chaveData = `data${tipoPrazo}`;
        let chaveHora = `hora${tipoPrazo}`;

        if (this[chaveData]?.isValid() && this[chaveHora]?.isValid()) {
            let dataHora = moment(
                `${this[chaveData].format('DD/MM/YYYY')} ${this[chaveHora].format('HH:mm:ss')}`,
                'DD/MM/YYYY HH:mm:ss'
            );

            if (dataHora.isValid()) {
                return dataHora.format('DD-MM-YYYY-HH-mm-ss');
            }
        }
    }

    handleChangeOrigem = (event) => {
        this.sistemaOrigem = event.target.value;
        this.pautaJulgamento.id = `${event.target.value}--`;

        if (this.isMeioJulgamentoVirtualDesabilitado) {
            this.meioJulgumentoSessaoVirtualTela = false;
            this.regrasResolucaoCnj591Form = this.regrasResolucaoCnj591Default;
            this.limparDataHoraInicioVotacaoVirtual();
            this.limparDataHoraFimVotacaoVirtual();
        }
    };

    handleTogglePautaLiberada = (event) => {
        this.pautaJulgamento.pautaLiberada = !!event.target.checked;
    };

    handleChangeTipo = (event) => {
        this.pautaJulgamento.tipo = event.target.value;
        if (this.idInicial) {
            let idParsed = this.parseSessaoId();
            if (idParsed.origem === Configuracao.ORIGEM_SIJ) {
                this.pautaJulgamento.id = this.toSessaoId(
                    idParsed.origem,
                    idParsed.numero,
                    idParsed.ano,
                    this.pautaJulgamento.tipo,
                    idParsed.codOrgaoJudic
                );
            }
        }
    };

    handleChangeNumeroPauta = async (event) => {
        let numPauta = event.target.value;
        let regex = /^\d{0,3}$/;

        if (!regex.test(numPauta)) {
            this.mensagemStore.abrirMensagemErro('Informe valor para número da pauta até 999.');
            return false;
        }

        let idParsed = this.parseSessaoId();
        this.pautaJulgamento.id = this.toSessaoId(
            idParsed.origem,
            numPauta,
            idParsed.ano,
            idParsed.tipo,
            idParsed.codOrgaoJudic
        );
    };

    handleConfirmacaoModal = () => {
        this.mostrarModalConfirmacao = false;
        this.salvarPautaJulgamento();
    };

    handleCancelarModal = () => {
        this.mostrarModalConfirmacao = false;
    };

    get todosCamposBloqueados() {
        return this.isDataInicioJaPassou;
    }

    get edicaoNumeroPautaDisabled() {
        return (
            this.todosCamposBloqueados ||
            !this.idInicial ||
            this.origemPauta === Configuracao.ORIGEM_PJE ||
            this.pautaComProcessos
        );
    }

    get edicaoTipoPautaDisabled() {
        return (
            this.todosCamposBloqueados ||
            !!(this.idInicial && this.origemPauta === Configuracao.ORIGEM_SIJ && this.pautaComProcessos)
        );
    }

    parseSessaoId() {
        let retorno = {
            origem: null,
            idOrigem: null,
            sessaoId: null
        };

        if (this.pautaJulgamento?.id) {
            let partes = this.pautaJulgamento.id.split('--');
            retorno.origem = partes[0];
            retorno.idOrigem = partes.length === 2 && partes[1].length > 0 ? partes[1] : null;

            if (retorno.idOrigem) {
                retorno.sessaoId = this.pautaJulgamento.id;
                // @ts-ignore
                let partesInternas = retorno.idOrigem.split('-');
                retorno.numero = partesInternas[0].length > 0 ? partesInternas[0] : null;
                if (partesInternas.length === 4) {
                    retorno.ano = partesInternas[1];
                    retorno.tipo = partesInternas[2];
                    retorno.codOrgaoJudic = partesInternas[3];
                }
            }
        }
        return retorno;
    }

    toSessaoId(origem, numero, ano, tipo, codOrgaoJudic) {
        let retorno = `${origem}--${numero}`;
        if (origem === Configuracao.ORIGEM_SIJ) {
            retorno += `-${ano}-${tipo}-${codOrgaoJudic}`;
        }
        return retorno;
    }

    handleChangeModalidadeSessaoJulgamento = (event) => {
        this.pautaJulgamento.tipoJulgamento = event.target.value;
    };

    handleChangeMeioJulgamentoSessaoJulgamento = (event) => {
        let meioJulgumentoSessaoJulgamento = event.target.checked;

        if (meioJulgumentoSessaoJulgamento === false) {
            this.pautaJulgamento.tipoJulgamento = MEIO_JULGAMENTO_SESSAO.VIRTUAL.codigo;
        } else if (this.pautaJulgamento.tipoJulgamento === MEIO_JULGAMENTO_SESSAO.VIRTUAL.codigo) {
            this.pautaJulgamento.tipoJulgamento = MEIO_JULGAMENTO_SESSAO.SALA_DE_SESSAO_COM_PERIODO_VIRTUAL.codigo;
        }
    };

    handleChangeMeioJulgamentoVotacaoVirtual = (event) => {
        this.meioJulgumentoSessaoVirtualTela = event.target.checked;
        this.limparDataHoraInicioVotacaoVirtual();
        this.limparDataHoraFimVotacaoVirtual();
    };

    get meioJulgumentoSessaoJulgamento() {
        return this.pautaJulgamento?.tipoJulgamento !== MEIO_JULGAMENTO_SESSAO.VIRTUAL.codigo;
    }

    get meioJulgumentoSessaoVirtual() {
        return this.meioJulgumentoSessaoVirtualTela !== undefined
            ? this.meioJulgumentoSessaoVirtualTela
            : this.pautaJulgamentoInicial && this.meioJulgumentoSessaoVirtualInicial;
    }

    get meioJulgumentoSessaoVirtualInicial() {
        return (
            this.preenchido(this.pautaJulgamentoInicial.prazos.dataInicioVotacaoVirtual) &&
            this.preenchido(this.pautaJulgamentoInicial.prazos.dataFimVotacaoVirtual)
        );
    }

    handleChangeRegrasPeriodoVirtual = (event) => {
        this.regrasResolucaoCnj591Form = event.target.value === 'true';
        this.handleClickGerarDatasJulgamentoVirtual();
    };

    get regrasResCnj591() {
        return this.regrasResolucaoCnj591Form;
    }

    isIntervaloValido(dataObj) {
        const ano = dataObj.year();
        return ano >= 2016 && ano <= 2099;
    }

    handleChangeDataInicioVotacaoVirtual = (dataObj) => {
        if (dataObj?.isValid() && this.isIntervaloValido(dataObj)) {
            this.alterarData(dataObj, 'InicioVotacaoVirtual');
            this.gerarDatasVotacao();
        }
    };

    handleChangeHoraInicioVotacaoVirtual = (horaObj) => {
        if (horaObj?.isValid()) {
            this.alterarHora(horaObj, 'InicioVotacaoVirtual');
            this.gerarDatasVotacao();
        }
    };

    handleChangeDataFimVotacaoVirtual = (dataObj) => {
        this.alterarData(dataObj, 'FimVotacaoVirtual');
        if (dataObj?.isValid() && this.isIntervaloValido(dataObj)) {
            this.gerarDatasVotacao();
        }
    };

    handleChangeHoraFimVotacaoVirtual = (horaObj) => {
        this.alterarHora(horaObj, 'FimVotacaoVirtual');
        if (horaObj?.isValid()) {
            this.gerarDatasVotacao();
        }
    };

    handleChangeDataInicioSessaoPresencial = (dataObj) => {
        this.alterarData(dataObj, 'InicioSessaoPresencial');
        if (dataObj?.isValid() && this.isIntervaloValido(dataObj)) {
            this.gerarDatasVotacao();
        }
    };

    handleChangeHoraInicioSessaoPresencial = async (horaObj) => {
        this.alterarHora(horaObj, 'InicioSessaoPresencial');
        if (horaObj?.isValid()) {
            this.gerarDatasVotacao();
        }
    };

    alterarData(dataObj, tipoPrazo) {
        this[`data${tipoPrazo}`] = dataObj ? dataObj.clone() : null;
    }

    alterarHora(horaObj, tipoPrazo) {
        this[`hora${tipoPrazo}`] = horaObj ? horaObj.clone() : null;
    }

    limparDataHoraInicioVotacaoVirtual = () => {
        if (!this.todosCamposBloqueados) {
            this.alterarData(null, 'InicioVotacaoVirtual');
            this.alterarHora(moment().set('hour', 0).set('minute', 0).set('second', 0), 'InicioVotacaoVirtual');
        }
    };

    limparDataHoraFimVotacaoVirtual = () => {
        if (!this.todosCamposBloqueados) {
            this.alterarData(null, 'FimVotacaoVirtual');
            this.alterarHora(moment().set('hour', 0).set('minute', 0).set('second', 0), 'FimVotacaoVirtual');
            this.isFimVotacaoVirtualDiaUtil = undefined;
        }
    };

    limparDataHoraInicioSessaoPresencial = () => {
        if (!this.todosCamposBloqueados) {
            this.alterarData(null, 'InicioSessaoPresencial');
            this.alterarHora(null, 'InicioSessaoPresencial');
        }
    };

    handleClickGerarDatasJulgamentoVirtual = () => {
        if (this.meioJulgumentoSessaoJulgamento) {
            if (!this.dataHoraInicioSessaoPresencialValida) {
                this.mensagemStore.abrirMensagemAlerta('Informe uma data/hora válida para a sessão de julgamento.');
                return;
            }
        } else if (this.meioJulgumentoSessaoVirtual) {
            if (!this.dataHoraInicioVotacaoVirtualValida && !this.dataHoraFimVotacaoVirtualValida) {
                this.mensagemStore.abrirMensagemAlerta(
                    'Informe uma data/hora válida para o início ou fim do julgamento virtual.'
                );
                return;
            }
        }

        return this.gerarDatasVotacao();
    };

    gerarDatasVotacao = async () => {
        let prazos;

        if (this.meioJulgumentoSessaoJulgamento && this.meioJulgumentoSessaoVirtual) {
            console.log('Configurando datas para sessão presencial com sessão virtual vinculada...');

            if (this.dataHoraInicioSessaoPresencialValida) {
                console.log('Data e hora de sessão são válidas.');
                const dataInicioSessaoPresencial = moment(
                    this.dataHoraInicioSessaoPresencial,
                    'DD-MM-YYYY-HH-mm-ss',
                    true
                );

                console.log('Requisitando cálculo de datas do período virtual...');
                prazos = await this.sessaoService.recuperarDatasVotacaoVirtual(
                    dataInicioSessaoPresencial.format('DD-MM-YYYY-HH-mm-ss'),
                    this.regrasResCnj591
                );
            }
        } else if (this.meioJulgumentoSessaoVirtual) {
            console.log('Configurando datas para sessão exclusivamente virtual...');
            if (this.dataHoraInicioVotacaoVirtualValida) {
                console.log('Data e hora de início do período virtual são válidas.');
                const dataInicioSessaoVirtual = moment(this.dataHoraInicioVotacaoVirtual, 'DD-MM-YYYY-HH-mm-ss', true);

                console.log('Requisitando cálculo de datas do período virtual pela data de início da virtual...');
                prazos = await this.sessaoService.recuperarDatasVotacaoPelaDataInicio(
                    dataInicioSessaoVirtual.format('DD-MM-YYYY-HH-mm-ss'),
                    this.regrasResCnj591
                );
            }
        } else if (this.meioJulgumentoSessaoJulgamento) {
            console.log('Sessão exclusivamente presencial... não há necessidade de cálculo de datas.');
        }

        runInAction(() => {
            if (prazos) {
                if (prazos.dataInicioSessaoPresencial) {
                    this.pautaJulgamento.prazos.dataInicioSessaoPresencial = prazos.dataInicioSessaoPresencial;
                    this.configurarDataHoraTela('InicioSessaoPresencial');
                } else if (this.dataHoraInicioSessaoPresencialValida) {
                    this.pautaJulgamento.prazos.dataInicioSessaoPresencial =
                        this.getDataHoraFormatada('InicioSessaoPresencial');
                }

                if (this.meioJulgumentoSessaoVirtual) {
                    this.pautaJulgamento.prazos.dataInicioVotacaoVirtual = prazos.dataInicioVotacaoVirtual;
                    this.configurarDataHoraTela('InicioVotacaoVirtual');
                    this.pautaJulgamento.prazos.dataFimVotacaoVirtual = prazos.dataFimVotacaoVirtual;
                    this.isFimVotacaoVirtualDiaUtil = prazos.dataFimVotacaoVirtualDiaUtil;
                    this.pautaJulgamento.prazos.dataFimVotacaoVirtualExibicao = prazos.dataFimVotacaoVirtualExibicao;
                    this.configurarDataHoraTela('FimVotacaoVirtual');
                    this.configurarDataHoraTela('FimVotacaoVirtualExibicao');
                }

                this.pautaJulgamento.prazos.regrasResolucaoCnj591 = prazos.regrasResolucaoCnj591;
                this.regrasResolucaoCnj591Form = prazos.regrasResolucaoCnj591;
            } else if (this.dataInicioSessaoPresencial) {
                this.pautaJulgamento.prazos.dataInicioSessaoPresencial =
                    this.dataInicioSessaoPresencial.format('DD-MM-YYYY-HH-mm-ss');
            }
        });
    };

    get dataHoraInicioSessaoPresencialValida() {
        return this.dataInicioSessaoPresencial?.isValid() && this.horaInicioSessaoPresencial?.isValid();
    }

    get dataHoraInicioVotacaoVirtualValida() {
        return this.dataInicioVotacaoVirtual?.isValid() && this.horaInicioVotacaoVirtual?.isValid();
    }

    get dataHoraFimVotacaoVirtualValida() {
        return this.dataFimVotacaoVirtual?.isValid() && this.horaFimVotacaoVirtual?.isValid();
    }

    get tituloOperacao() {
        return this.sessaoId ? 'Editar' : 'Criar';
    }

    get magistrados() {
        return this.dominioStore.opcoesMagistradosAutoComplete();
    }

    get origemPauta() {
        if (this.pautaJulgamento?.id) {
            this.sistemaOrigem = this.pautaJulgamento.id.split('--')[0];
        }

        return this.sistemaOrigem;
    }

    get sessaoId() {
        if (this.pautaJulgamento?.id) {
            return this.pautaJulgamento.id.split('--')[1];
        }

        return '';
    }

    get numeroPauta() {
        return this.sessaoId.split('-')[0];
    }

    get pautaPublicada() {
        if (!this.pautaJulgamento?.prazos?.dataPublicacaoPauta) {
            return false;
        }

        return !moment(this.pautaJulgamento.prazos.dataPublicacaoPauta, 'DD-MM-YYYY-HH-mm-ss')
            .startOf('day')
            .isAfter(moment().endOf('day'), 'day');
    }

    get tipo() {
        return this.pautaJulgamento?.tipo ? this.pautaJulgamento.tipo : '';
    }

    get modalidadeSessaoJulgamento() {
        return this.pautaJulgamento?.tipoJulgamento ? this.pautaJulgamento.tipoJulgamento : '';
    }

    render() {
        return (
            <Dialog
                open={!!this.sessaoStore?.pautaJulgamentoModal}
                maxWidth="xl"
                fullWidth
                slotProps={{
                    paper: {
                        sx: { height: 'auto' }
                    }
                }}
            >
                {this.sessaoStore?.carregandoPautaModal ? (
                    <DialogContent
                        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 300 }}
                    >
                        <CircularProgress />
                    </DialogContent>
                ) : (
                    <>
                        {this.renderDialogTitle()}
                        {this.renderDialogContent()}
                        {this.renderDialogActions()}
                    </>
                )}
            </Dialog>
        );
    }

    renderDialogTitle() {
        return (
            <DialogTitle style={{ display: 'flex' }}>
                {this.tituloOperacao + ' pauta ' + (this.sessaoId ? this.pautaJulgamento.id : '')}
            </DialogTitle>
        );
    }

    renderAlerta(mensagem) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', width: '100%', marginBottom: '12px' }}>
                <Warning style={{ fill: 'darkorange' }} />
                <Typography style={{ color: 'darkorange', fontWeight: 'bold', marginLeft: '8px', marginTop: '2px' }}>
                    &nbsp;&nbsp; {mensagem}
                </Typography>
            </div>
        );
    }

    renderDialogContent() {
        return (
            <DialogContent style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {this.pautaPublicada && this.renderAlerta('Atenção: Esta pauta já está publicada.')}
                {this.isDataInicioJaPassou &&
                    this.renderAlerta('Atenção: Não é permitida a edição da pauta de uma sessão já iniciada.')}
                {this.idInicial &&
                    this.origemPauta === Configuracao.ORIGEM_SIJ &&
                    this.pautaComProcessos &&
                    this.renderAlerta(
                        'Atenção: Edição de número e tipo da pauta para SIJ somente é possível em pautas sem processos.'
                    )}

                {this.renderIdentificacaoPauta()}
                {this.renderConfiguracaoJulgamento()}
                {this.renderSituacaoPauta()}
            </DialogContent>
        );
    }

    renderIdentificacaoPauta() {
        return (
            <div style={{ display: 'flex', alignItems: 'center', width: '100%', padding: '10px 0px' }}>
                <Card style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                    <CardHeader
                        title={<Typography variant="h6">Identificação da pauta</Typography>}
                        sx={{ pb: 0 }}
                    />
                    <CardContent style={{ paddingBottom: '0px' }}>
                        {this.parametroStore.isOrgaoTST && (
                            <div style={{ display: 'flex', alignItems: 'center', width: '100%', marginBottom: '8px' }}>
                                <FormLabel
                                    component="legend"
                                    required={true}
                                    sx={{ width: larguraColunaLabel }}
                                >
                                    Sistema de origem
                                </FormLabel>
                                <RadioGroup
                                    row
                                    value={this.origemPauta}
                                    onChange={this.handleChangeOrigem}
                                >
                                    <FormControlLabel
                                        label="PJe"
                                        value={Configuracao.ORIGEM_PJE}
                                        control={<Radio />}
                                        style={{ marginRight: '70px', width: '120px' }}
                                        disabled={this.isOrigemPautaDesabilitado}
                                    />
                                    <FormControlLabel
                                        label="eSIJ"
                                        value={Configuracao.ORIGEM_SIJ}
                                        control={<Radio />}
                                        style={{ marginRight: '70px' }}
                                        disabled={this.isOrigemPautaDesabilitado}
                                    />
                                </RadioGroup>
                            </div>
                        )}
                        {this.parametroStore.isOrgaoTST && <Divider />}
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%', margin: '8px 0px' }}>
                            <FormLabel
                                component="legend"
                                required={true}
                                sx={{ width: larguraColunaLabel }}
                            >
                                Tipo de pauta
                            </FormLabel>
                            <RadioGroup
                                row
                                name="tipo-pauta"
                                value={this.tipo}
                                onChange={this.handleChangeTipo}
                            >
                                <FormControlLabel
                                    label="Ordinária"
                                    value={Configuracao.TIPO_PAUTA_ORDINARIA}
                                    control={<Radio />}
                                    style={{ marginRight: '70px', width: '120px' }}
                                    disabled={this.edicaoTipoPautaDisabled}
                                />
                                <FormControlLabel
                                    label="Extraordinária"
                                    value={Configuracao.TIPO_PAUTA_EXTRAORDINARIA}
                                    control={<Radio />}
                                    style={{ marginRight: '70px' }}
                                    disabled={this.edicaoTipoPautaDisabled}
                                />
                            </RadioGroup>
                        </div>
                        {this.origemPauta === Configuracao.ORIGEM_SIJ && this.idInicial && (
                            <div style={{ display: 'flex', alignItems: 'center', width: '100%', margin: '8px 0px' }}>
                                <FormLabel
                                    component="legend"
                                    required={true}
                                    style={{
                                        width: larguraColunaLabel,
                                        color: this.parseSessaoId().numero ? 'rgba(0, 0, 0, 0.54)' : 'orange'
                                    }}
                                >
                                    Número de pauta
                                </FormLabel>
                                <TextField
                                    value={this.numeroPauta}
                                    style={{ width: '50px' }}
                                    onChange={this.handleChangeNumeroPauta}
                                    disabled={this.edicaoNumeroPautaDisabled}
                                />
                            </div>
                        )}
                    </CardContent>
                </Card>
            </div>
        );
    }

    renderConfiguracaoJulgamento() {
        return (
            <div style={{ display: 'flex', alignItems: 'center', width: '100%', padding: '10px 0px' }}>
                <Card style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                    <CardHeader
                        title={<Typography variant="h6">Configuração do julgamento</Typography>}
                        sx={{ pb: 0 }}
                    />
                    <CardContent style={{ marginBottom: '8px' }}>
                        {this.renderMeioJulgamento()}
                        <Divider />
                        {this.renderModalidadeSessaoJulgamento()}
                        <Divider />
                        {this.renderRegrasPeriodoVirtual()}
                        <Divider />
                        {this.renderPeriodoSessaoJulgamento()}
                        {this.renderCamposSessaoVirtual()}
                    </CardContent>
                </Card>
            </div>
        );
    }

    renderRegrasPeriodoVirtual() {
        return (
            <Stack
                direction="row"
                width="100%"
                alignItems="center"
            >
                <FormLabel
                    id="regras-prazo-periodo-julgamento-virtual-label"
                    required={true}
                    sx={{ width: larguraColunaLabel }}
                >
                    Regras do período virtual
                </FormLabel>
                <RadioGroup
                    row
                    aria-labelledby="regras-prazo-periodo-julgamento-virtual-label"
                    name="regras-prazo-periodo-julgamento-virtual"
                    value={this.regrasResCnj591}
                    onChange={this.handleChangeRegrasPeriodoVirtual}
                >
                    <FormControlLabel
                        value="false"
                        control={<Radio />}
                        label="Anteriores à Res. 591/2024 do CNJ"
                        sx={{ width: '320px' }}
                        disabled={this.todosCamposBloqueados}
                    />
                    <FormControlLabel
                        value="true"
                        control={<Radio />}
                        label="Vigentes após 14/03/2025 00:00"
                        disabled={this.todosCamposBloqueados}
                    />
                </RadioGroup>
            </Stack>
        );
    }

    renderMeioJulgamento() {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    width: '100%'
                }}
            >
                <FormLabel
                    style={{
                        width: larguraColunaLabel,
                        color:
                            !this.meioJulgumentoSessaoJulgamento && !this.meioJulgumentoSessaoVirtual
                                ? 'orange'
                                : 'rgba(0, 0, 0, 0.54)'
                    }}
                    component="legend"
                    required={true}
                >
                    Meio(s) de julgamento
                </FormLabel>
                <FormGroup sx={{ display: 'flex', flexDirection: 'row', flexGrow: 1 }}>
                    <Stack
                        direction={'row'}
                        alignItems={'center'}
                        alignContent={'flex-start'}
                    >
                        <FormControlLabel
                            control={<Checkbox checked={this.meioJulgumentoSessaoJulgamento} />}
                            label={MEIO_JULGAMENTO_SESSAO.SALA_DE_SESSAO_COM_PERIODO_VIRTUAL.descricaoCurta}
                            onChange={this.handleChangeMeioJulgamentoSessaoJulgamento}
                            sx={{ width: '280px' }}
                            disabled={this.todosCamposBloqueados}
                        />
                        <FormControlLabel
                            control={<Checkbox checked={this.meioJulgumentoSessaoVirtual} />}
                            label={MEIO_JULGAMENTO_SESSAO.VIRTUAL.descricaoCurta}
                            onChange={this.handleChangeMeioJulgamentoVotacaoVirtual}
                            disabled={this.isMeioJulgamentoVirtualDesabilitado}
                        />
                        {this.isMeioJulgamentoVirtualIndisponivel && (
                            <Tooltip
                                title={<Typography>Indisponível por determinação da Administração.</Typography>}
                                placement="top"
                            >
                                <Warning sx={{ fontSize: '22px', color: 'darkorange' }} />
                            </Tooltip>
                        )}
                    </Stack>
                </FormGroup>
            </Box>
        );
    }

    get titlePresencial() {
        return <Typography align="justify">Sessão Presencial, com ou sem julgamento virtual vinculado.</Typography>;
    }

    get titleHibrida() {
        return (
            <>
                <Typography align="justify">
                    Sessão Presencial e Telepresencial, simultaneamente, conforme definição apresentada no § 1º do art.
                    3º do ATO CONJUNTO TST.GP.GVP.CGJT Nº 217, DE 23 DE AGOSTO DE 2021 (sessão realizada com
                    participantes presentes na sala de sessão e por meio telepresencial).
                </Typography>
                <Typography align="justify">Opção desabilitada em 19 DE MARÇO DE 2025, a pedido da SEGJUD.</Typography>
            </>
        );
    }

    get titleTelepresencial() {
        return (
            <>
                <Typography align="justify">
                    Sessão Telepresencial, com ou sem julgamento virtual vinculado, conforme definição apresentada no
                    ATO CONJUNTO TST.GP.GVP.CGJT Nº 173, DE 30 DE ABRIL DE 2020.
                </Typography>
                <Typography align="justify">
                    Opção desabilitada para atender ao ATO CONJUNTO TST.GP.GVP.CGJT Nº 657, DE 25 DE OUTUBRO DE 2022,
                    que revogou o ato nº 173.
                </Typography>
            </>
        );
    }

    renderModalidadeSessaoJulgamento() {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    width: '100%'
                }}
            >
                <FormLabel
                    component="legend"
                    required={this.meioJulgumentoSessaoJulgamento}
                    sx={{ width: larguraColunaLabel }}
                >
                    Modalidade da sessão de julgamento
                </FormLabel>
                <RadioGroup
                    value={this.modalidadeSessaoJulgamento}
                    onChange={this.handleChangeModalidadeSessaoJulgamento}
                    sx={{ display: 'flex', flexDirection: 'row', flexGrow: 1 }}
                >
                    <Stack
                        direction="row"
                        alignItems={'center'}
                    >
                        <FormControlLabel
                            label={MODALIDADE_SESSAO_JULGAMENTO.PRESENCIAL.descricao}
                            value={MODALIDADE_SESSAO_JULGAMENTO.PRESENCIAL.id}
                            control={<Radio />}
                            disabled={this.todosCamposBloqueados || !this.meioJulgumentoSessaoJulgamento}
                            sx={{ mr: 0.5 }}
                        />
                        <Tooltip
                            title={this.titlePresencial}
                            placement="left-start"
                        >
                            <InfoIcon style={{ color: 'darkblue', fontSize: '22px' }} />
                        </Tooltip>
                    </Stack>
                    <Stack
                        direction="row"
                        alignItems={'center'}
                        sx={{ ml: 5 }}
                    >
                        <FormControlLabel
                            sx={{ mr: 0.5 }}
                            label={MODALIDADE_SESSAO_JULGAMENTO.TELEPRESENCIAL.descricao}
                            value={MODALIDADE_SESSAO_JULGAMENTO.TELEPRESENCIAL.id}
                            control={<Radio />}
                            disabled={
                                this.todosCamposBloqueados ||
                                !this.meioJulgumentoSessaoJulgamento ||
                                !this.isComponenteHabilitado('CriacaoPautaTelepresencial')
                            }
                        />
                        <Tooltip
                            title={this.titleTelepresencial}
                            placement="left-start"
                        >
                            <InfoIcon style={{ color: 'darkblue', fontSize: '22px' }} />
                        </Tooltip>
                    </Stack>
                    <Stack
                        direction="row"
                        alignItems={'center'}
                        sx={{ ml: 5 }}
                    >
                        <FormControlLabel
                            sx={{ mr: 0.5 }}
                            label={MODALIDADE_SESSAO_JULGAMENTO.HIBRIDA.descricao}
                            value={MODALIDADE_SESSAO_JULGAMENTO.HIBRIDA.id}
                            control={<Radio />}
                            disabled={
                                this.todosCamposBloqueados ||
                                !this.meioJulgumentoSessaoJulgamento ||
                                !this.isComponenteHabilitado('CriacaoPautaHibrida')
                            }
                        />
                        <Tooltip
                            title={this.titleHibrida}
                            placement="left-start"
                        >
                            <InfoIcon style={{ color: 'darkblue', fontSize: '22px' }} />
                        </Tooltip>
                    </Stack>
                </RadioGroup>
            </Box>
        );
    }

    renderPeriodoSessaoJulgamento() {
        return (
            this.meioJulgumentoSessaoJulgamento && (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: '100%',
                        margin: '8px 0px'
                    }}
                >
                    <Tooltip
                        placement="top"
                        title={this.getTooltipInicioSessaoPresencial()}
                    >
                        <FormLabel
                            component="legend"
                            required={true}
                            style={{
                                width: '550px',
                                color: !this.dataHoraInicioSessaoPresencial ? 'orange' : 'rgba(0, 0, 0, 0.54)'
                            }}
                        >
                            Data/hora da sessão de julgamento
                        </FormLabel>
                    </Tooltip>
                    <div style={{ display: 'flex' }}>
                        {this.renderDateTimePicker('InicioSessaoPresencial')}
                        <Tooltip
                            title="Limpar data/hora"
                            placement="top"
                        >
                            <Clear
                                style={{ cursor: 'pointer', marginTop: '4px', marginLeft: '8px' }}
                                onClick={this.limparDataHoraInicioSessaoPresencial}
                            />
                        </Tooltip>
                    </div>
                </div>
            )
        );
    }

    getTooltipInicioSessaoPresencial() {
        let mensagens = [];

        if (!this.dataInicioSessaoPresencial) {
            mensagens.push('ALERTA: A data da sessão de julgamento não foi informada.');
        }
        if (!this.horaInicioSessaoPresencial) {
            mensagens.push('ALERTA: A hora da sessão de julgamento não foi informada.');
        }

        if (mensagens.length === 0) {
            return null;
        }

        return (
            <Box>
                {mensagens.map((mensagem) => (
                    <Typography key={this.nextKey}>{mensagem}</Typography>
                ))}
            </Box>
        );
    }

    renderCamposSessaoVirtual() {
        return (
            this.meioJulgumentoSessaoVirtual && (
                <div style={{ display: 'flex', width: '100%' }}>
                    <div style={{ display: 'flex', width: '550px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                            <Tooltip
                                placement="top"
                                title={this.getTooltipInicioVotacaoVirtual()}
                            >
                                <FormLabel
                                    component="legend"
                                    required={this.meioJulgumentoSessaoVirtual}
                                    style={{
                                        color:
                                            this.meioJulgumentoSessaoVirtual && !this.dataHoraInicioVotacaoVirtual
                                                ? 'orange'
                                                : 'rgba(0, 0, 0, 0.54)'
                                    }}
                                >
                                    Data/hora de início do período de julgamento virtual
                                </FormLabel>
                            </Tooltip>
                            <Tooltip
                                placement="top"
                                title={this.getTooltipFimVotacaoVirtual()}
                            >
                                <FormLabel
                                    component="legend"
                                    required={this.meioJulgumentoSessaoVirtual}
                                    style={{
                                        color:
                                            this.meioJulgumentoSessaoVirtual &&
                                            (!this.dataHoraFimVotacaoVirtualExibicao ||
                                                this.isFimVotacaoVirtualDiaUtil === false)
                                                ? 'orange'
                                                : 'rgba(0, 0, 0, 0.54)'
                                    }}
                                    disabled={this.todosCamposBloqueados}
                                >
                                    Data/hora de fim do período de julgamento virtual
                                </FormLabel>
                            </Tooltip>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '110px' }}>
                            <Tooltip title={<Typography>Calcular período de julgamento virtual</Typography>}>
                                <IconButton
                                    onClick={this.handleClickGerarDatasJulgamentoVirtual}
                                    size="large"
                                    disabled={this.todosCamposBloqueados}
                                >
                                    <DateRange />
                                </IconButton>
                            </Tooltip>
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%', margin: '5px 0px' }}>
                            <div style={{ display: 'flex' }}>
                                {this.renderDateTimePicker(
                                    'InicioVotacaoVirtual',
                                    !this.meioJulgumentoSessaoVirtual,
                                    true
                                )}
                                <Tooltip
                                    title="Limpar data/hora"
                                    placement="top"
                                >
                                    <Clear
                                        style={{ cursor: 'pointer', marginTop: '4px', marginLeft: '8px' }}
                                        onClick={this.limparDataHoraInicioVotacaoVirtual}
                                    />
                                </Tooltip>
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%', margin: '5px 0px' }}>
                            <div style={{ display: 'flex' }}>
                                {this.renderDateTimePicker('FimVotacaoVirtualExibicao', true, true)}
                            </div>
                        </div>
                    </div>
                </div>
            )
        );
    }

    getTooltipInicioVotacaoVirtual() {
        let mensagens = [];

        if (this.meioJulgumentoSessaoVirtual && !this.dataInicioVotacaoVirtual) {
            mensagens.push('ALERTA: A data de início do julgamento virtual não foi informada.');
        }

        if (this.meioJulgumentoSessaoVirtual && !this.horaInicioVotacaoVirtual) {
            mensagens.push('ALERTA: A hora de início do julgamento virtual não foi informada.');
        }

        if (mensagens.length === 0) {
            return null;
        }

        return (
            <Box>
                {mensagens.map((mensagem) => (
                    <Typography key={this.nextKey}>{mensagem}</Typography>
                ))}
            </Box>
        );
    }

    getTooltipFimVotacaoVirtual() {
        let mensagens = [];

        if (this.meioJulgumentoSessaoVirtual && !this.dataFimVotacaoVirtual) {
            mensagens.push('ALERTA: A data de fim do julgamento virtual não foi informada.');
        }

        if (this.meioJulgumentoSessaoVirtual && !this.horaFimVotacaoVirtual) {
            mensagens.push('ALERTA: A hora de fim do julgamento virtual não foi informada.');
        }

        if (this.meioJulgumentoSessaoVirtual && this.isFimVotacaoVirtualDiaUtil === false) {
            mensagens.push('ALERTA: A data de fim do julgamento deve ser dia útil.');
        }

        if (mensagens.length === 0) {
            return null;
        }

        return (
            <Box>
                {mensagens.map((mensagem) => (
                    <Typography key={this.nextKey}>{mensagem}</Typography>
                ))}
            </Box>
        );
    }

    renderSituacaoPauta() {
        if (this.origemPauta !== Configuracao.ORIGEM_SIJ) {
            return null;
        }

        return (
            <Box sx={{ alignItems: 'center', width: '100%', padding: '10px 0px' }}>
                <Card style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                    <CardHeader
                        title={<Typography variant="h6">Situação da pauta</Typography>}
                        sx={{ pb: 0 }}
                    />
                    <CardContent style={{ marginBottom: '8px' }}>
                        <Box sx={{ alignItems: 'center', width: '100%' }}>
                            <Stack
                                direction="row"
                                spacing={1}
                                sx={{ alignItems: 'center', alignContent: 'center' }}
                            >
                                <Typography>Pauta NÃO liberada</Typography>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={!!this.pautaJulgamento?.pautaLiberada}
                                            onChange={this.handleTogglePautaLiberada}
                                            disabled={this.todosCamposBloqueados}
                                        />
                                    }
                                    label={null}
                                />
                                <Typography>Pauta liberada</Typography>
                            </Stack>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        );
    }

    handleDialogPautaLiberada = () => {
        this.confirmacaoPautaLiberada = true;
    };

    handleDialogPautaLiberadaFechar = () => {
        this.confirmacaoPautaLiberada = false;
    };

    renderDialogConfirmacao() {
        return (
            <ModalConfirmacao
                open={this.confirmacaoPautaLiberada}
                callbackFechar={this.handleDialogPautaLiberadaFechar}
                titulo="Editar pauta publicada"
                textoBotaoCancelamento="Cancelar"
                tipoConfirmacao={TIPO_CONFIRMACAO.ATUALIZACAO}
                textoBotaoConfirmacao="Salvar"
                callbackCancelar={this.handleDialogPautaLiberadaFechar}
                callbackConfirmar={this.handleClickConfirmar}
            >
                <div style={{ display: 'flex', alignItems: 'center', width: '100%', marginBottom: '12px' }}>
                    <Warning style={{ fill: 'darkorange' }} />
                    <Typography
                        style={{
                            color: 'darkorange',
                            fontWeight: 'bold',
                            marginLeft: '10px',
                            marginTop: '2px',
                            fontSize: '16px'
                        }}
                    >
                        Atenção: Esta pauta já está publicada. Deseja confirmar as alterações?
                    </Typography>
                </div>
            </ModalConfirmacao>
        );
    }

    renderDialogActions() {
        return (
            <DialogActions sx={{ mt: 2, ml: 3, mr: 3, mb: 2 }}>
                <Button
                    disabled={this.salvandoDados}
                    onClick={this.fecharModalCriarOuEditarPauta}
                    color="secondary"
                    variant="outlined"
                    endIcon={<CancelIcon />}
                >
                    Cancelar
                </Button>
                <Tooltip
                    placement="top"
                    title={this.tooltipBotaoSalvar}
                >
                    <span>
                        <Button
                            color="primary"
                            variant="outlined"
                            endIcon={<SaveIcon />}
                            onClick={this.pautaPublicada ? this.handleDialogPautaLiberada : this.handleClickConfirmar}
                            disabled={this.todosCamposBloqueados || this.temPendencias || this.salvandoDados}
                        >
                            Salvar
                        </Button>
                        {this.confirmacaoPautaLiberada && this.renderDialogConfirmacao()}
                    </span>
                </Tooltip>
                <ModalConfirmacao
                    open={this.mostrarModalConfirmacao}
                    titulo="Confirmação de inclusão de pauta"
                    tipoConfirmacao={TIPO_CONFIRMACAO.INCLUSAO}
                    callbackCancelar={this.handleCancelarModal}
                    callbackConfirmar={this.handleConfirmacaoModal}
                >
                    <Typography display={'inline'}>
                        A data selecionada é um feriado. Deseja realmente salvar a pauta nesta data?
                    </Typography>
                </ModalConfirmacao>
            </DialogActions>
        );
    }

    get mensagensMeioJulgamento() {
        let mensagens = [];

        if (this.meioJulgumentoSessaoJulgamento) {
            if (!this.dataInicioSessaoPresencial) {
                mensagens.push('Informe a data da sessão de julgamento.');
            }

            if (!this.horaInicioSessaoPresencial) {
                mensagens.push('Informe a hora da sessão de julgamento.');
            }
        }

        return mensagens;
    }

    get mensagensJulgamentoVirtual() {
        let mensagens = [];

        if (this.meioJulgumentoSessaoVirtual) {
            if (!this.dataInicioVotacaoVirtual) {
                mensagens.push('Informe a data de início do período de julgamento virtual.');
            }
            if (!this.horaInicioVotacaoVirtual) {
                mensagens.push('Informe a hora de início do período de julgamento virtual.');
            }
            if (!this.dataFimVotacaoVirtual) {
                mensagens.push('Informe a data de fim do período de julgamento virtual.');
            }
            if (!this.horaFimVotacaoVirtual) {
                mensagens.push('Informe a hora de fim do período de julgamento virtual.');
            }
            if (this.isFimVotacaoVirtualDiaUtil === false) {
                mensagens.push('ALERTA: A data de fim do julgamento deve ser dia útil.');
            }
        }

        return mensagens;
    }

    get tooltipBotaoSalvar() {
        let mensagens = [];
        mensagens = mensagens.concat(this.mensagensMeioJulgamento);
        mensagens = mensagens.concat(this.mensagensJulgamentoVirtual);

        if (mensagens.length === 0) {
            return null;
        }

        return (
            <Box>
                {mensagens.map((mensagem) => (
                    <Typography key={this.nextKey}>{mensagem}</Typography>
                ))}
            </Box>
        );
    }

    validarData(data) {
        return this.preenchido(data) && this.dataValida(data);
    }

    get isOrigemPautaDesabilitado() {
        return this.todosCamposBloqueados || !!this.sessaoId;
    }

    get isMeioJulgamentoVirtualDesabilitado() {
        return this.todosCamposBloqueados || this.isMeioJulgamentoVirtualIndisponivel;
    }

    get isMeioJulgamentoVirtualIndisponivel() {
        return !this.isMeioJulgamentoVirtualPJeHabilitado() && this.origemPauta === Configuracao.ORIGEM_PJE;
    }

    dataValida(campo) {
        return moment(campo, 'DD-MM-YYYY-HH-mm-ss', true).isValid();
    }

    naoPreenchido(campo) {
        return !campo || campo === '';
    }

    preenchido(campo) {
        return !this.naoPreenchido(campo);
    }

    get temPendencias() {
        const pendencias =
            this.naoPreenchido(this.pautaJulgamento?.tipoJulgamento) ||
            this.naoPreenchido(this.pautaJulgamento?.tipo) ||
            this.carregando ||
            (this.meioJulgumentoSessaoVirtual && this.isFimVotacaoVirtualDiaUtil === false) ||
            (this.meioJulgumentoSessaoJulgamento && !this.validarData(this.dataHoraInicioSessaoPresencial)) ||
            (this.meioJulgumentoSessaoVirtual && !this.validarData(this.dataHoraInicioVotacaoVirtual)) ||
            (this.meioJulgumentoSessaoVirtual && !this.validarData(this.dataHoraFimVotacaoVirtual)) ||
            (this.pautaJulgamento?.tipoJulgamento === MEIO_JULGAMENTO_SESSAO.VIRTUAL.codigo &&
                !this.validarData(this.dataHoraFimVotacaoVirtual)) ||
            (this.idInicial && !this.parseSessaoId().numero);

        return pendencias;
    }

    renderDateTimePicker(tipoPrazo, disabled, virtual = false) {
        const chaveData = `data${tipoPrazo}`;
        const funcaoChangeData = `handleChangeData${tipoPrazo}`;
        const chaveHora = `hora${tipoPrazo}`;
        const funcaoChangeHora = `handleChangeHora${tipoPrazo}`;

        return (
            <>
                <DatePicker
                    value={this[chaveData]}
                    onChange={this[funcaoChangeData]}
                    slotProps={{
                        textField: {
                            helperText: (() => {
                                const data = this[chaveData];

                                if (data) {
                                    if (!data.isValid()) {
                                        return 'Data inválida';
                                    }

                                    if (!this.isIntervaloValido(data)) {
                                        return 'A data informada contém um ano inválido';
                                    }

                                    if (this.dominioStore.ehFeriadoVotacao(data)) {
                                        return 'A data informada é um feriado';
                                    }
                                }

                                return '';
                            })(),
                            FormHelperTextProps: (() => {
                                const data = this[chaveData];
                                return {
                                    style: {
                                        color: data && this.dominioStore.ehFeriadoVotacao(data) ? orange[600] : red[600]
                                    }
                                };
                            })()
                        }
                    }}
                    disabled={this.todosCamposBloqueados || disabled}
                />
                <span style={{ marginLeft: '16px' }}>
                    <TimePicker
                        ampm={false}
                        value={this[chaveHora]}
                        onChange={this[funcaoChangeHora]}
                        slotProps={{
                            textField: {
                                helperText: this[chaveHora] && !this[chaveHora].isValid() && 'Hora inválida'
                            }
                        }}
                        disabled={this.todosCamposBloqueados || (virtual ? true : disabled)}
                    />
                </span>
            </>
        );
    }
}

export default inject('stores')(observer(CriarOuEditarPauta));
